<template>
  <div>
    <Breadcrumbs />
    <div class="wrapper mt-5 mb-5 pb-5">
      <div class="container">
        <div class="mw-custom password_forgot" style="--w:580">
          <h1 class="mb-4 text-black forgot-title">{{ $t("password_forgot") }}</h1>
          <p class="password-desc">{{ $t("forgot_password_text") }}</p>
          <div class="mb-5">
            <b-form-group
              :label="$t('form_email') + '*'"
              label-for="email"
              :description="description"
              class="form-label pt-0 pt-md-3"
            >
              <b-form-input
                id="email"
                v-model="email"
                type="text"
                :state="emailState"
                aria-describedby="email-feedback"
                class="form-control"
                :placeholder="$t('email_placeholder')"
              ></b-form-input>
              <b-form-invalid-feedback id="email-feedback">
                {{ emailError }}
              </b-form-invalid-feedback>
            </b-form-group>
          </div>
          <div class="d-flex flex-column justify-content-between align-items-center flex-sm-row align-items-sm-end reset-button">
            <b-link @click="$router.back()" class="order-2 order-sm-1 mt-0 mt-md-4 mt-sm-0 go-back-link" style="text-decoration: underline;">&lt; {{ $t("go_back") }}</b-link>
            <button @click="formSubmit" class="btn btn-primary btn-lg px-5 order-1 order-sm-2 w-custom form_button" style="--w-sm:100%">
              {{ $t("reset_my_password") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumbs from "@/esf_antarctica_lederhosenland/core/components/breadcrumb/Breadcrumbs.vue";
import { forgotPassword } from "@storefront/core/data-resolver/user";
import config from "@config";
export default {
  name: "ForgotPassword",
  components: {
    Breadcrumbs,
  },
  mounted() {
    const bcrumb = { current: this.$t("password_forgot"), routes: [] };
    this.$store.commit("breadcrumbs/set", bcrumb);
  },
  metaInfo() {
    return {
      meta: [
        { name: "title", content: this.$t("password_forgot") },
        { name: "keywords", content: this.$t("password_forgot") },
        { name: "description", content: this.$t("password_forgot") },
      ],
      title: this.$t("password_forgot"),
      link: [{ rel: "canonical", href: config.app_url + this.$route.fullPath }],
    };
  },
  data() {
    return {
      email: "",
      emailState: null,
      emailError: "",
      description: "",
      emailReg:
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
    };
  },
  methods: {
    async formSubmit() {
      if (this.validateEmail()) {
        const retval = await forgotPassword(this.email);
        if (retval == true) {
          this.description = this.$t("reset_password_email_has_been_sent");
          const msg = {
            type: "success",
            title: "",
            text: this.description,
          };
          this.$store.dispatch("messages/sendMessage", { message: msg });
        } else {
          this.description = this.$t(
            "reset_password_email_could_not_been_sent"
          );
        }
      }
    },
    validateEmail() {
      if (this.email == "") {
        this.emailState = false;
        this.emailError = this.$t("email_is_required_field");
        return false;
      }
      if (!this.emailReg.test(this.email)) {
        this.emailState = false;
        this.emailError = this.$t("email_is_invalid_field");
        return false;
      }
      this.emailState = true;
      return true;
    },
  },
};
</script>

<style lang="scss" scoped>
.forgot {
  .auth-title {
    padding-bottom: 15px;
    border-bottom: 0;
  }
  .submit-btn {
    margin-top: 23px;
  }
  .go-back {
    margin-top: 25px;
  }
}
</style>